import { useTranslation } from 'react-i18next';

import { QuillInput } from '@treams/treams-ui';

import Property from './Property';

export default function Paragraph(props: { label?: string; name?: string }) {
	const { t } = useTranslation();

	return (
		<Property
			title={props.label ?? t('common.settings.evaluationForms.properties.paragraph.title')}
		>
			<QuillInput.Localizable.Formik name={props.name ?? 'title'} hasMediaUpload />
		</Property>
	);
}
